import React from 'react';
import ContentLoader from 'react-content-loader';
import { WithStyles, withStyles } from '@material-ui/core';

import styles from './LumaBotFlowSessionLogLoading.styles';

const HEIGHT = 72;
const WIDTH = '100%';
const NUMBER_OF_ROWS = 8;

type Props = WithStyles<typeof styles>;

const LumaBotFlowSessionLogLoading: React.FunctionComponent<Props> = ({ classes }) => {
  const numberOfSkeletonRows = Array(NUMBER_OF_ROWS).fill(null);

  return (
    <div className={classes.container}>
      {numberOfSkeletonRows.map(() => (
        <ContentLoader height={HEIGHT} width={WIDTH}>
          <rect x="0" y="0" rx="0" ry="0" height={HEIGHT} width={WIDTH} />
        </ContentLoader>
      ))}
    </div>
  );
};

export default withStyles(styles)(LumaBotFlowSessionLogLoading);
